import styled, { css } from 'styled-components';
export const Group = styled.div `
  display: flex;
  flex-direction: ${({ $direction }) => $direction};

  ${({ $space }) => $space === 'small' &&
    css `
      gap: var(--space-50);
    `}

  ${({ $space }) => $space === 'medium' &&
    css `
      gap: var(--space-200);
    `}

  ${({ $space }) => $space === 'large' &&
    css `
      gap: var(--space-400);
    `}

  ${({ $space }) => $space === 'xlarge' &&
    css `
      gap: var(--space-500);
    `}

  ${({ $fullWidth }) => $fullWidth &&
    css `
      width: 100%;
    `}

  ${({ $justify }) => $justify === 'right' &&
    css `
      justify-content: flex-end;
    `}

  ${({ $align }) => $align === 'center' &&
    css `
      align-items: center;
    `}
`;
